module.exports = __webpack_public_path__ + "static/media/AJ.ed01832c.png";